import { DateRangeType } from '@fluentui/date-time-utilities/lib/dateValues/dateValues';
import { assertNever } from 'owa-assert';
import loc, { format } from 'owa-localize';
import { goToNextDayText } from 'owa-locstrings/lib/strings/gotonextdaytext.locstring.json';
import { goToPreviousDayText } from 'owa-locstrings/lib/strings/gotopreviousdaytext.locstring.json';
import {
    goToPreviousWeekStringText,
    goToNextWeekStringText,
    goToPreviousMonthText,
    goToNextMonthStringText,
    goToTodayDateText,
} from 'owa-calendar-shared-strings/lib/strings/calendarSurfaceCommandBar.locstring.json';
import {
    getNextSurfaceDateRangeString,
    getPreviousSurfaceDateRangeString,
} from 'owa-calendar-surface-surface-store';
import { formatMonthDayYear } from 'owa-datetime';
import { observableToday } from 'owa-observable-datetime';

export function getPreviousLabel(currentDateRangeType: DateRangeType) {
    let currentViewPreviousLabel: string = '';
    switch (currentDateRangeType) {
        case DateRangeType.Day:
            currentViewPreviousLabel = loc(goToPreviousDayText);
            break;
        case DateRangeType.WorkWeek:
            currentViewPreviousLabel = loc(goToPreviousWeekStringText);
            break;
        case DateRangeType.Week:
            currentViewPreviousLabel = loc(goToPreviousWeekStringText);
            break;
        case DateRangeType.Month:
            currentViewPreviousLabel = loc(goToPreviousMonthText);
            break;
        default:
            assertNever(currentDateRangeType);
    }

    return format(currentViewPreviousLabel, '\n' + getPreviousSurfaceDateRangeString());
}

export function getNextLabel(currentDateRangeType: DateRangeType) {
    let currentViewNextLabel: string = '';

    switch (currentDateRangeType) {
        case DateRangeType.Day:
            currentViewNextLabel = loc(goToNextDayText);
            break;
        case DateRangeType.WorkWeek:
            currentViewNextLabel = loc(goToNextWeekStringText);
            break;
        case DateRangeType.Week:
            currentViewNextLabel = loc(goToNextWeekStringText);
            break;
        case DateRangeType.Month:
            currentViewNextLabel = loc(goToNextMonthStringText);
            break;
        default:
            assertNever(currentDateRangeType);
    }
    return format(currentViewNextLabel, '\n' + getNextSurfaceDateRangeString());
}

export function getTodayLabel() {
    return format(loc(goToTodayDateText), '\n' + formatMonthDayYear(observableToday()));
}
